exports.default = {
  'agent_center': '智能助理中心',
  'create_agent': '建立智能助理',
  'search_results': '{keyword}的搜索結果',
  'found_agents': '（找到{count}個相關智能助理）',
  'no_search_results': '沒有搜尋結果，請嘗試其他關鍵字',
  'relevance': '相關性',
  'most_popular': '最受歡迎',
  'latest_released': '最近發布',
  'i_created': '我的',
  'recommended': '推薦',
  'your_agents': '您的智能體',
  'loading': '加載中',
  'no_more': '沒有更多了',
  'settings': '設置',
  'delete': '刪除',
  'confirm_delete_agent': '確定刪除智能體？',
  'delete_agent_warning': '刪除智能體將無法撤銷。用戶將不能訪問你的智能體，所有 Prompt 編排配置和日誌均將一併被刪除。',
  'subscription_incomplete': '訂閱未完成，稍後請查看賬單',
  'order_cancelled': '訂單已取消',
  'no_custom_agents': '暫無自定義智能助理'
}
